const defaultState = {
  login:{
    username: null,
    user_display_name: null, 
    token: null,
    islogin: false,
    roles: [],
    IS_ADMIN: false,
    IS_USER: false,
    IS_FARMACIA: false,
    user_id: null,
    userprofile: null,  
    idPrestador: null
  },
  authenticated: false,
  msj:''
};

export default (state = defaultState, action) => {
    switch (action.type){
        case 'LOGIN_OK':
            return {
                ...state, 
                login: {
                    user_id: action.payload._id,
                    username: action.payload.usuario,
                    user_display_name: action.payload.usuario,
                    //token: action.payload.token,
                    roles: action.payload.rol,
                    islogin:true,
                    IS_ADMIN: action.payload.rol === 'admin' ? true : false,
                    IS_USER: action.payload.rol === 'prestadorventas' ? true : false,
                    IS_FARMACIA: action.payload.rol === 'prestadoradmin' ? true : false,
                    idPrestador: action.payload.idPrestador
                },
                authenticated: true
            }
        case 'LOGOUT':
            return {
                ...state, 
                login:{
                    username: null,
                    user_display_name: null, 
                    //token: null,
                    islogin: false,
                    roles: [],
                    IS_ADMIN: false,
                    IS_USER: false,
                    IS_FARMACIA: false,
                    user_id: null,
                    userprofile: null,  
                  },
                  authenticated: false
            }
        case 'ERROR_LOGIN':
            return {
                ...state, 
                msj:'Usuario o clave incorrectos'
            }
        default:
                return state;                   
    }   
}

